// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container das Abas */
.tab-container {
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
    margin-bottom: 20px;

}

/* Navegação das Abas */
.tab-header {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    flex-wrap: wrap;
    margin-left: 20px;
}

.tab-button {
    background-color: #e0e6f1;
    color: #333;
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.tab-button:hover {
    background-color: #d0d9e8;
}

.tab-button.active {
    background-color: #007bff;
    color: white;
}

/* Conteúdo da Aba */
.tab-content {
    background-color: #fff;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
    font-size: 14px;
    color: #555;
}

/* Responsividade */
@media (max-width: 768px) {
    .tab-header {
        flex-direction: column;
    }

    .tab-button {
        width: 100%;
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/FiltroTabs.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,mBAAmB;;AAEvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,+CAA+C;IAC/C,eAAe;IACf,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":["/* Container das Abas */\n.tab-container {\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    font-family: 'Arial', sans-serif;\n    margin-bottom: 20px;\n\n}\n\n/* Navegação das Abas */\n.tab-header {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 15px;\n    flex-wrap: wrap;\n    margin-left: 20px;\n}\n\n.tab-button {\n    background-color: #e0e6f1;\n    color: #333;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.tab-button:hover {\n    background-color: #d0d9e8;\n}\n\n.tab-button.active {\n    background-color: #007bff;\n    color: white;\n}\n\n/* Conteúdo da Aba */\n.tab-content {\n    background-color: #fff;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n    font-size: 14px;\n    color: #555;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n    .tab-header {\n        flex-direction: column;\n    }\n\n    .tab-button {\n        width: 100%;\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
